import { render } from "./Tutela.vue?vue&type=template&id=0ba9516c&scoped=true"
import script from "./Tutela.vue?vue&type=script&lang=js"
export * from "./Tutela.vue?vue&type=script&lang=js"

import "./Tutela.vue?vue&type=style&index=0&id=0ba9516c&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba9516c"]])

export default __exports__